import { z } from "zod";

const organisationDetailsSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
});
type OrganisationDetailsFormData = z.infer<typeof organisationDetailsSchema>;

export { organisationDetailsSchema };
export type { OrganisationDetailsFormData };
